import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import Button from '@material-ui/core/Button'
import { toggleBottomNav } from 'actions/template'
import { last } from 'lodash'
import language from 'utils/vast-languagepack'

export default connect(
  state => ({
    navDisplayed: state.email.bottomNavigationDisplayed,
    value: state.tasks.addOrEdit.fields.selectedActionPrediction.value,
    emailCardSelected: last(state.email.cardSelected),
  }),
  dispatch => bindActionCreators({ toggleBottomNav }, dispatch)
)(({ toggleBottomNav, navDisplayed, value, emailCardSelected }) => {
  return value === 'sms' ||
    (value === 'email' && emailCardSelected === 'blank') ? (
    <span>
      <Button onClick={toggleBottomNav}>
        {navDisplayed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
        {language.task.add.taskDetails}
      </Button>
    </span>
  ) : null;
})
